import {ComponentType} from "react";
import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {BrandCalendarIcon, BrandCheckboxCheckedIcon, CheckIcon} from "@pg-design/icons-module";
import {Highlight, Text} from "@pg-design/text-module";
import {upperFirst} from "@pg-mono/nodash";
import {RP_RESERVATION_TEST_IDS} from "@pg-mono/test-ids";

import {getPropertyNoun} from "../../offer/utils/get_property_noun";
import {RESERVATION_CONFIRMED_BUTTON_TEXT, RESERVATION_CONFIRMED_TITLES} from "../constants/reservation_copy";
import {IReservationConfirmedStepContentProps, ReservationConfirmedVariant} from "../types/IReservationConfirmedStepContentProps";
import {reservationStepCenteredContentStyle, reservationStepTextStyle} from "./reservation_step_styles";
import {renderUntranslatedSuffix} from "./reservation_text";

interface IProps extends IReservationConfirmedStepContentProps {
    className?: string;
}

type IConfirmedTextProps = Omit<IReservationConfirmedStepContentProps, "variant" | "onClose">;

interface IConfirmedVariantContent {
    Illustration: ComponentType;
    // the title and the description of the step
    Texts: ComponentType<IConfirmedTextProps>;
}

const CalendarIllustration = () => (
    <div aria-hidden="true" className={calendarIllustrationStyle}>
        <BrandCalendarIcon width={104} height={104} />
        <span className={calendarCheckStyle}>
            <CheckIcon width={20} height={20} />
        </span>
    </div>
);

const CheckboxIllustration = () => (
    <div aria-hidden="true">
        <BrandCheckboxCheckedIcon width={96} height={96} wrapperType="circle" wrapperSize="9.6" wrapperColor="var(--colors-beige-subtle)" />
    </div>
);

const Reservation24hTexts = (props: IConfirmedTextProps) => {
    const {titleId, descriptionId, propertyNumber, offerType, vendorName} = props;
    const noun = getPropertyNoun(offerType);

    return (
        <>
            <Text as="h2" id={titleId} variant="headline_4" align="center" color="var(--colors-secondary)">
                {RESERVATION_CONFIRMED_TITLES.reservation_24h}
            </Text>

            <Text as="p" id={descriptionId} variant="body_copy_2" align="center" color="var(--colors-gray-800)">
                {upperFirst(noun.nominative)}
                {renderUntranslatedSuffix(propertyNumber)} jest {noun.reservedParticiple} dla Ciebie na 24 godziny.{" "}
                <strong>
                    Deweloper
                    {renderUntranslatedSuffix(vendorName)} skontaktuje się z Tobą
                </strong>{" "}
                telefonicznie lub mailowo, aby umówić spotkanie.
            </Text>
        </>
    );
};

const SubmittedTexts = (props: IConfirmedTextProps) => {
    const {titleId, descriptionId} = props;

    return (
        <>
            <Text as="h2" id={titleId} variant="headline_4" align="center" color="var(--colors-secondary)">
                <Highlight>{RESERVATION_CONFIRMED_TITLES.submitted}</Highlight>
            </Text>

            <Text as="p" id={descriptionId} variant="body_copy_1" align="center" color="var(--colors-gray-800)">
                <strong>Oczekuj na kontakt od dewelopera</strong> w sprawie bezpłatnej rezerwacji.
            </Text>
        </>
    );
};

const CONFIRMED_VARIANT_CONTENT: Record<ReservationConfirmedVariant, IConfirmedVariantContent> = {
    reservation_24h: {Illustration: CalendarIllustration, Texts: Reservation24hTexts},
    submitted: {Illustration: CheckboxIllustration, Texts: SubmittedTexts}
};

// The host modal renders no header here - the button is the only way out besides the overlay
export const ReservationConfirmedStepContent = (props: IProps) => {
    const {variant, onClose, className, ...textProps} = props;
    const {Illustration, Texts} = CONFIRMED_VARIANT_CONTENT[variant];

    return (
        <div className={cx(reservationStepCenteredContentStyle, className)}>
            <Illustration />

            <div role="status" className={reservationStepTextStyle}>
                <Texts {...textProps} />
            </div>

            <Button
                type="button"
                variant="filled_primary"
                size="medium"
                fullWidth
                onClick={onClose}
                dataTestId={RP_RESERVATION_TEST_IDS.CONFIRMED_CLOSE_BUTTON}
            >
                {RESERVATION_CONFIRMED_BUTTON_TEXT}
            </Button>
        </div>
    );
};

const calendarIllustrationStyle = css({
    position: "relative",
    display: "flex"
});

const calendarCheckStyle = css({
    position: "absolute",
    right: "0.4rem",
    bottom: "0.8rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "3.2rem",
    height: "3.2rem",
    borderWidth: "2px",
    borderStyle: "solid",
    borderColor: "var(--colors-secondary)",
    borderRadius: "50%",
    backgroundColor: "var(--colors-white)"
});
import {ComponentType} from "react";
import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {BrandCalendarIcon, BrandCheckboxCheckedIcon, CheckIcon} from "@pg-design/icons-module";
import {Highlight, Text} from "@pg-design/text-module";
import {upperFirst} from "@pg-mono/nodash";
import {RP_RESERVATION_TEST_IDS} from "@pg-mono/test-ids";

import {getPropertyNoun} from "../../offer/utils/get_property_noun";
import {RESERVATION_CONFIRMED_BUTTON_TEXT, RESERVATION_CONFIRMED_TITLES} from "../constants/reservation_copy";
import {IReservationConfirmedStepContentProps, ReservationConfirmedVariant} from "../types/IReservationConfirmedStepContentProps";
import {reservationStepCenteredContentStyle, reservationStepTextStyle} from "./reservation_step_styles";
import {renderUntranslatedSuffix} from "./reservation_text";

interface IProps extends IReservationConfirmedStepContentProps {
    className?: string;
}

type IConfirmedTextProps = Omit<IReservationConfirmedStepContentProps, "variant" | "onClose">;

interface IConfirmedVariantContent {
    Illustration: ComponentType;
    // the title and the description of the step
    Texts: ComponentType<IConfirmedTextProps>;
}

const CalendarIllustration = () => (
    <div aria-hidden="true" className={calendarIllustrationStyle}>
        <BrandCalendarIcon width={104} height={104} />
        <span className={calendarCheckStyle}>
            <CheckIcon width={20} height={20} />
        </span>
    </div>
);

const CheckboxIllustration = () => (
    <div aria-hidden="true">
        <BrandCheckboxCheckedIcon width={96} height={96} wrapperType="circle" wrapperSize="9.6" wrapperColor="var(--colors-beige-subtle)" />
    </div>
);

const Reservation24hTexts = (props: IConfirmedTextProps) => {
    const {titleId, descriptionId, propertyNumber, offerType, vendorName} = props;
    const noun = getPropertyNoun(offerType);

    return (
        <>
            <Text as="h2" id={titleId} variant="headline_4" align="center" color="var(--colors-secondary)">
                {RESERVATION_CONFIRMED_TITLES.reservation_24h}
            </Text>

            <Text as="p" id={descriptionId} variant="body_copy_2" align="center" color="var(--colors-gray-800)">
                {upperFirst(noun.nominative)}
                {renderUntranslatedSuffix(propertyNumber)} jest {noun.reservedParticiple} dla Ciebie na 24 godziny.{" "}
                <strong>
                    Deweloper
                    {renderUntranslatedSuffix(vendorName)} skontaktuje się z Tobą
                </strong>{" "}
                telefonicznie lub mailowo, aby umówić spotkanie.
            </Text>
        </>
    );
};

const SubmittedTexts = (props: IConfirmedTextProps) => {
    const {titleId, descriptionId} = props;

    return (
        <>
            <Text as="h2" id={titleId} variant="headline_4" align="center" color="var(--colors-secondary)">
                <Highlight>{RESERVATION_CONFIRMED_TITLES.submitted}</Highlight>
            </Text>

            <Text as="p" id={descriptionId} variant="body_copy_1" align="center" color="var(--colors-gray-800)">
                <strong>Oczekuj na kontakt od dewelopera</strong> w sprawie bezpłatnej rezerwacji.
            </Text>
        </>
    );
};

const CONFIRMED_VARIANT_CONTENT: Record<ReservationConfirmedVariant, IConfirmedVariantContent> = {
    reservation_24h: {Illustration: CalendarIllustration, Texts: Reservation24hTexts},
    submitted: {Illustration: CheckboxIllustration, Texts: SubmittedTexts}
};

// The host modal renders no header here - the button is the only way out besides the overlay
export const ReservationConfirmedStepContent = (props: IProps) => {
    const {variant, onClose, className, ...textProps} = props;
    const {Illustration, Texts} = CONFIRMED_VARIANT_CONTENT[variant];

    return (
        <div className={cx(reservationStepCenteredContentStyle, className)}>
            <Illustration />

            <div role="status" className={reservationStepTextStyle}>
                <Texts {...textProps} />
            </div>

            <Button
                type="button"
                variant="filled_primary"
                size="medium"
                fullWidth
                onClick={onClose}
                dataTestId={RP_RESERVATION_TEST_IDS.CONFIRMED_CLOSE_BUTTON}
            >
                {RESERVATION_CONFIRMED_BUTTON_TEXT}
            </Button>
        </div>
    );
};

const calendarIllustrationStyle = css({
    position: "relative",
    display: "flex"
});

const calendarCheckStyle = css({
    position: "absolute",
    right: "0.4rem",
    bottom: "0.8rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "3.2rem",
    height: "3.2rem",
    borderWidth: "2px",
    borderStyle: "solid",
    borderColor: "var(--colors-secondary)",
    borderRadius: "50%",
    backgroundColor: "var(--colors-white)"
});
